import React from 'react'
import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`

const Container = styled.div`
  background-color: white;
  border-radius: 28px;
  padding: 16px 24px;
  display: flex;
  gap: 24px;
  align-items: center;
`

const SkeletonBase = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
`

const AvatarSkeleton = styled(SkeletonBase)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`

const Content = styled.div`
  flex: 1;
`

const NameSkeleton = styled(SkeletonBase)`
  height: 20px;
  width: 150px;
  margin-bottom: 8px;
`

const PointsSkeleton = styled(SkeletonBase)`
  height: 16px;
  width: 80px;
`

const PositionSkeleton = styled(SkeletonBase)`
  height: 24px;
  width: 24px;
`

export function LeaderboardItemSkeleton() {
  return (
    <Container>
      <AvatarSkeleton />
      <Content>
        <NameSkeleton />
        <PointsSkeleton />
      </Content>
      <PositionSkeleton />
    </Container>
  )
}
